import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import React, { useContext, useEffect } from 'react';
import classnames from 'classnames';
import noop from '../../../../utils/noop';
import { DropdownStateContext } from '../../../DropdownStateManager';
import StandardMenuOption from '../StandardMenuOption';
import { useMenuItemHotkeys } from '../hooks';
import { itemWithOnSelect } from '../utils';
import s from './StandardMenuGroup.scss';
const StandardMenuGroup = ({ id , item: { className: groupClassName , disabled: groupDisabled , items  } , className , itemClassName , hideCheckIcon , withHoverEffect , onPassGroupStart =noop , onPassGroupEnd =noop , focused , startIndexOnFocus , onSelect , onSearch , onPressHome , onPressEnd  })=>{
    const { isOpen , firstKeyInteraction  } = useContext(DropdownStateContext);
    const { handleKeyboardEvents , currentIndex , setCurrentIndex  } = useMenuItemHotkeys(items.length, {
        onPassStart: ()=>{
            onPassGroupStart();
            setCurrentIndex(null);
        },
        onPassEnd: ()=>{
            onPassGroupEnd();
            setCurrentIndex(null);
        },
        onPressHome,
        onPressEnd,
        onSearch
    });
    useEffect(()=>{
        if (isOpen && focused) {
            setCurrentIndex(startIndexOnFocus !== null && startIndexOnFocus !== void 0 ? startIndexOnFocus : 0);
        } else {
            setCurrentIndex(null);
        }
    }, [
        isOpen,
        firstKeyInteraction,
        setCurrentIndex,
        startIndexOnFocus,
        focused
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['menu-group'], groupClassName, className),
        tabIndex: 0,
        onKeyDown: (e)=>{
            if (focused) {
                handleKeyboardEvents(e);
                e.stopPropagation();
            }
        },
        role: "group"
    }, items.map((item, idx)=>/*#__PURE__*/ React.createElement(StandardMenuOption, {
            id: `${id}-option-${idx}`,
            item: _object_spread_props(_object_spread({}, itemWithOnSelect(item, onSelect)), {
                disabled: groupDisabled || item.disabled
            }),
            className: itemClassName,
            hideCheckIcon: hideCheckIcon,
            withHoverEffect: withHoverEffect,
            focused: idx === currentIndex,
            key: `item_${item.value}_${idx}`
        })));
};
StandardMenuGroup.displayName = 'StandardMenuGroup';
export default StandardMenuGroup;
